"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INumericalBoundaryDefinitionSchema = void 0;
exports.isBoundaryNumericalDefinition = isBoundaryNumericalDefinition;
const zod_1 = require("zod");
const BoundaryAssertionType_1 = require("./BoundaryAssertionType");
const BoundarySourceType_1 = require("./BoundarySourceType");
const NumericalBoundary_1 = require("../NumericalBoundary");
exports.INumericalBoundaryDefinitionSchema = zod_1.z.object({
    type: zod_1.z.literal(BoundaryAssertionType_1.BoundaryAssertionType.Numerical),
    sourceType: BoundarySourceType_1.BoundarySourceTypeSchema.optional(),
    numerical: zod_1.z.lazy(() => NumericalBoundary_1.NumericalBoundarySchema),
});
function isBoundaryNumericalDefinition(boundary) {
    return boundary.type === BoundaryAssertionType_1.BoundaryAssertionType.Numerical;
}
//# sourceMappingURL=INumericalBoundaryDefinition.js.map